/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-unused-vars */
import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormControl from '@mui/material/FormControl';
import FilledInput from '@mui/material/FilledInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField from '@mui/material/TextField';
// import CircleIcon from '@mui/icons-material/Circle';
import LoginBg from '../assets/images/LoginBg.png';
import WelcomeDoor from '../assets/icons/Welcomedoor.svg';
import BsgLogo from '../assets/icons/BSG LogoWhite.svg';
import {
  // CenteredContainer,
  StyledText,
  VariableText,
} from '../components/Typography';
import Button from '../components/Button';
import { SERVICES } from '../components/Services';
import { ROUTES } from '../components/Routes';
import { post } from '../components/ApiHandler/apihandler';
import { useDispatch } from 'react-redux';
import { loginAction } from '../Redux/actions/authActions';
import { updateMemberIdAction } from '../Redux/actions/memberActions';
import NewFooter from '../components/Footer/NewFooter';
import { Link, Link as RouterLink } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { useState } from 'react';
// import ForgotScreenBG from '../../assets/images/Forgot-Screen-BG.png';
import ForgotScreenBG from '../assets/images/Forgot-Screen-BG.png';
// import NewImage from '../assets/images/Layer-653.jpg';
import NewImage from '../assets/images/bsg-contribg2.jpg';
import Loader from '../components/Loader/Loader';
import { Helmet } from 'react-helmet';

const MainContainer = styled.div`
  background-image: url(${NewImage});
  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  @media (max-width: 767px) {
    background-position: center 0px;
  }
`;
const LeftContainer = styled.div`
  min-height: 100vh;
  width: 30%;
  background: url(${LoginBg});
  background-size: cover;
  background-repeat: no-repeat;
  @media (max-width: 767px) {
    display: none;
  }
`;

const LeftContainerContent = styled.div`
  display: flex;
  gap: 25px;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const RightContainer = styled.div`
  width: 70%;
  @media (max-width: 767px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px auto;
  }
`;

const RightContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 15px;
  @media (max-width: 767px) {
    margin-top: 0;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 30%;
  padding: 0px 25px 0px 25px;
  box-sizing: border-box;
  border-radius: 0px 0px 10px 10px;
  background: rgb(255 255 255 / 71%);
  @media (max-width: 767px) {
    width: 95%;
  }
`;

const BtnController = styled.div`
  margin-top: 20px;
  @media (max-width: 767px) {
    margin-top: 20px;
  }
`;

const Label = styled.div`
  display: flex;
  justify-content: space-between;
  justify-content: space-between;
  width: -webkit-fill-available;
`;

const UpperDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30%;
  background: #fff;
  padding-top: 15px;
  border-radius: 10px 10px 0px 0px;
  padding-bottom: 5px;
  @media (max-width: 767px) {
    width: 95%;
  }
`;

const validationSchema = Yup.object().shape({
  memberId: Yup.string().required('Member ID is required'),
  password: Yup.string().required('Password is required'),
});

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const TITLE = 'Login - BSG Contribution Site';
  const formik = useFormik({
    initialValues: {
      memberId: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { memberId, password } = values;
      const url = SERVICES.CONTRIBUTION_LOGIN;
      setIsButtonDisabled(true);
      setIsLoading(true);
      try {
        const response = await post(url, { memberId, password });
        const xAuthToken = response.headers.get('X-Auth-Token');
        console.log(response);
        if (response.ok) {
          localStorage.setItem('X-Auth-Token', xAuthToken);
          dispatch(loginAction());
          dispatch(updateMemberIdAction(memberId));
          if (xAuthToken !== null) {
            navigate(ROUTES.OTP_AUTHENTICATION_PAGE);
          }
        } else {
          formik.setFieldError('SubmitError', 'Invalid MemberID or Password');
          setIsButtonDisabled(false);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Error:', error);
        setIsButtonDisabled(false);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
        setIsButtonDisabled(false);
      }
    },
  });

  const handleClickShowPassword = () => {
    formik.setFieldValue('showPassword', !formik.values.showPassword);
  };
  const handleKeyDown = (e) => {
    if (['ArrowUp', 'ArrowDown', '-', '.', 'e', 'E'].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <MainContainer>
        <RightContainerContent>
          <UpperDiv>
            <img style={{ width: '60px' }} src={BsgLogo} alt="/Logo" />
            <Typography
              sx={{ fontWeight: '600', fontSize: '24px', color: '#484848' }}
            >
              Welcome
            </Typography>
            <Typography
              sx={{ fontWeight: '600', fontSize: '16px', color: '#484848' }}
            >
              Bharat Soka Gakkai Contribution Website
            </Typography>
          </UpperDiv>
          <Form onSubmit={formik.handleSubmit}>
            <StyledText fontWeight="600" Size="28" color="#484848">
              Login
            </StyledText>
            <StyledText fontWeight="500" Size="14px" color="#484848">
              Member ID (as per BDS)
            </StyledText>
            <TextField
              id="memberId"
              name="memberId"
              sx={{
                m: 1,
                width: '100%',
                marginLeft: '0',
                marginRight: '0',
                // background: '#fff',
                '& input': {
                  paddingTop: '7px !important',
                  paddingBottom: '7px !important',
                  '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button':
                    {
                      '-webkit-appearance': 'none',
                      margin: 0,
                    },
                },
              }}
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.memberId}
              error={formik.touched.memberId && formik.errors.memberId}
              type="number"
              onWheel={(e) => e.target.blur()}
              onKeyDown={handleKeyDown}
            />
            {formik.touched.memberId && formik.errors.memberId && (
              <StyledText color="red" fontWeight="500" Size="14px">
                {formik.errors.memberId}
              </StyledText>
            )}
            <Label>
              <StyledText fontWeight="500" Size="14px" color="#484848">
                Password
              </StyledText>
            </Label>
            <FormControl
              variant="filled"
              sx={{
                m: 1,
                width: '100%',
                marginLeft: '0',
                marginRight: '0',
                '& input': {
                  paddingTop: '7px !important',
                  paddingBottom: '7px !important',
                },
              }}
            >
              <FilledInput
                id="password"
                name="password"
                type={formik.values.showPassword ? 'text' : 'password'}
                disableUnderline={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                error={formik.touched.password && formik.errors.password}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {formik.values.showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            {formik.touched.password && formik.errors.password && (
              <StyledText color="red" fontWeight="500" Size="14px">
                {formik.errors.password}
              </StyledText>
            )}
            {formik.errors.SubmitError && (
              <StyledText color="red" fontWeight="500" Size="14px">
                {formik.errors.SubmitError}
              </StyledText>
            )}
            <BtnController>
              <Button type="submit" disabled={isButtonDisabled}>
                Login
              </Button>
            </BtnController>
            <Grid item sx={{ marginLeft: 'auto' }}>
              {' '}
              <p className="forgotPassword">
                <Link
                  to="/forgot-password"
                  style={{
                    textDecoration: 'under-line',
                    color: ' #449890',
                    fontWeight: '500',
                  }}
                >
                  New User/ Forgot Password
                </Link>
              </p>
            </Grid>
          </Form>
        </RightContainerContent>
      </MainContainer>
      <NewFooter />
      {isLoading && <Loader />}
    </>
  );
};

export default Login;
